import styled from "styled-components";
import { ColorV2 } from "config/colors";
import { TypographyV2 } from "config/font";
import { DetailBlock, DetailValue } from "../shiftDetailsModal.styled";

export const ApplicationsList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  max-height: 320px;
  overflow-y: auto;
`;

export const ActionButtons = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 16px;
  margin-left: 12px;
`;

export const IconActionButton = styled.button`
  background: transparent;
  border: 0;
  padding: 0;
  width: 30px;
  height: 30px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: opacity 140ms ease;

  &:hover:not(:disabled),
  &:focus-visible:not(:disabled) {
    opacity: 0.65;
  }

  &:disabled {
    cursor: default;
    opacity: 0.45;
  }
`;

export const ApplicationsCountBadge = styled.span`
  min-width: 20px;
  height: 20px;
  padding: 0 6px;
  border-radius: 999px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: ${ColorV2.NegativeRed};
  color: ${ColorV2.White};
  font-size: 12px;
  font-weight: 700;
  line-height: 1;
`;

export const RequestedRateBlock = styled.div`
  display: inline-flex;
  flex-direction: column;
  gap: 2px;
  min-width: 100px;
  margin-left: auto;
  margin-right: 16px;
`;

export const RequestedRateValue = styled.span`
  ${TypographyV2.b2}
  color: ${ColorV2.Blue1};
  line-height: 1.2;
`;

export const RequestedRateLabel = styled.span`
  ${TypographyV2.s1}
  color: ${ColorV2.Blue4};
  line-height: 1.2;
`;

export const RangeEditRow = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;

  > input,
  > div {
    width: 118px;
    min-width: 118px;
  }

  > span {
    ${TypographyV2.h4}
    color: ${ColorV2.Blue4};
    line-height: 1;
  }
`;

export const MotivationalLetterModalText = styled.p`
  ${TypographyV2.b2}
  color: ${ColorV2.Blue2};
  margin: 0;
  padding-bottom: 16px;
  max-height: min(55vh, 460px);
  overflow-y: auto;
  white-space: pre-wrap;
  word-break: break-word;
`;

export const EmployeesCountText = styled.span`
  ${TypographyV2.b2}
  color: ${ColorV2.Blue4};
  line-height: 1;
`;

export const EditSectionLayout = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const EditTopGrid = styled.div`
  display: grid;
  grid-template-columns: minmax(280px, 1fr) minmax(190px, 0.5fr);
  gap: 16px;
`;

export const EditBottomGrid = styled.div`
  display: grid;
  grid-template-columns: minmax(220px, 320px) minmax(0, 1fr);
  gap: 16px;
  align-items: end;
`;

export const EditDescriptionRow = styled.div`
  width: 100%;
`;

export const DescriptionInputWrap = styled.div`
  width: 100%;
`;

export const EditFieldLabel = styled.div`
  ${TypographyV2.s1}
  color: ${ColorV2.Blue4};
  margin-bottom: 6px;
`;

export const WorkerStepperRow = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 12px;
  min-height: 56px;
`;

export const WorkerStepperValue = styled.span`
  ${TypographyV2.h4}
  color: ${ColorV2.Blue1};
  min-width: 28px;
  text-align: center;
`;

export const SkillsInputRow = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  width: 100%;
`;

export const SkillsAddButtonRow = styled.div`
  flex: 0 0 auto;
  transform: translateY(6px);
`;

export const SkillsTags = styled.div`
  margin-top: 8px;
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
`;

export const RoleHintText = styled.div`
  ${TypographyV2.s1}
  color: ${ColorV2.Blue5};
  margin-top: 4px;
`;

export const GigDetailsContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 30px;
`;

export const SalaryDetailBlock = styled.div`
  margin-left: 12px;
`;

export const DescriptionDetailBlock = styled(DetailBlock)<{
  $hasLeadingField: boolean;
}>`
  grid-column: ${(props) => (props.$hasLeadingField ? "span 4" : "1 / -1")};
  min-width: 0;
`;

export const DescriptionDetailValue = styled(DetailValue)`
  white-space: pre-wrap;
  overflow-wrap: anywhere;
`;
